var map = {
	"./img/404.png": 65747,
	"./img/404.webp": 28466,
	"./img/about-2-bg.jpg": 39248,
	"./img/about-2.jpg": 48602,
	"./img/about.jpg": 81016,
	"./img/about/about-head-bg.jpg": 12925,
	"./img/about/about-head-bg.webp": 75400,
	"./img/about/about-page-section-one-bg.jpg": 53432,
	"./img/about/about-page-section-one-bg.webp": 72518,
	"./img/about/about-page-section-three-bg.png": 72956,
	"./img/about/about-page-section-three-bg.webp": 63352,
	"./img/about/about-page-section-two-bg-old.jpg": 37860,
	"./img/about/about-page-section-two-bg-old.webp": 89132,
	"./img/about/about-page-section-two-bg.jpg": 44003,
	"./img/about/about-page-section-two-bg.webp": 65881,
	"./img/about/vission-mission-2.jpg": 70776,
	"./img/about/vission-mission-3.jpeg": 35837,
	"./img/about/visson-mission-1.jpg": 24874,
	"./img/admin/VidhyaShree.jpg": 47234,
	"./img/admin/admin-07.jpg": 84054,
	"./img/admin/arpitha-g.jpeg": 26154,
	"./img/admin/arpitha-g.jpg": 46303,
	"./img/admin/chandrakalamohan.jpg": 43523,
	"./img/admin/haneef.jpg": 92918,
	"./img/admin/major-joyshree.jpg": 7483,
	"./img/admin/major.jpg": 29529,
	"./img/admin/mysore/akshata-1.jpeg": 23955,
	"./img/admin/mysore/akshata.jpg": 68124,
	"./img/admin/mysore/bharath-b-k.jpg": 41723,
	"./img/admin/mysore/francila-1.jpeg": 7841,
	"./img/admin/mysore/francila.jpeg": 23751,
	"./img/admin/mysore/gokulendu-h-l.jpg": 24673,
	"./img/admin/mysore/kiran-1.jpg": 43322,
	"./img/admin/mysore/kiran-raj.jpg": 30151,
	"./img/admin/mysore/maria-alphonso.jpg": 78038,
	"./img/admin/mysore/mary-infancia.jpg": 85155,
	"./img/admin/mysore/sheikh-shahul.jpg": 36418,
	"./img/admin/mysore/shobha-rani.jpg": 29225,
	"./img/admin/mysore/sumathi-hr-mysore.jpeg": 69797,
	"./img/admin/mysore/sumathi-mysore.jpg": 40997,
	"./img/admin/mysore/supriya.jpg": 22154,
	"./img/admin/mysore/varaprasad.jpeg": 61240,
	"./img/admin/mysore/vidya.jpg": 66976,
	"./img/admin/nandini.jpg": 11586,
	"./img/admin/old/major-joyshree.jpg": 68390,
	"./img/admin/old/nandini.jpg": 8658,
	"./img/admin/old/suchetha.jpeg": 93131,
	"./img/admin/parthasarathy.jpg": 25242,
	"./img/admin/ramanagara/santhosh-ramanagara.jpg": 8996,
	"./img/admin/ramanagara/sudha-ramanagara.jpg": 11125,
	"./img/admin/ramanagara/vijay-ramanagara.jpg": 21587,
	"./img/admin/ramya.jpg": 76282,
	"./img/admin/reshma-o.jpg": 71208,
	"./img/admin/reshma-old.jpg": 3353,
	"./img/admin/reshma.jpg": 70095,
	"./img/admin/shivkumar-ben.jpg": 40026,
	"./img/admin/shivu.jpg": 88476,
	"./img/admin/shivu1.jpg": 49166,
	"./img/admin/suchetha.jpg": 72726,
	"./img/admin/vanaja-dr.png": 71620,
	"./img/admin/vanaja-raman.png": 88764,
	"./img/admin/vishal.jpg": 50950,
	"./img/banner-new/career-page.jpg": 15338,
	"./img/banner-new/faqs.jpg": 75450,
	"./img/banner-new/patient-testimonial.jpg": 23243,
	"./img/bg-blog.jpg": 23244,
	"./img/bg-blog.webp": 28511,
	"./img/blog-new-1.jpg": 6712,
	"./img/blog-new-2.jpg": 90806,
	"./img/blog-new-3.jpg": 39941,
	"./img/blog/01.jpg": 93241,
	"./img/blog/02.jpg": 30308,
	"./img/blog/03.jpg": 38170,
	"./img/blog/04.jpg": 77493,
	"./img/blog/05.jpg": 59819,
	"./img/blog/06.jpg": 33351,
	"./img/blog/07.jpg": 16392,
	"./img/blog/08.jpg": 12404,
	"./img/blog/09.jpg": 34470,
	"./img/blog/10.jpg": 93081,
	"./img/blog/11.jpg": 89803,
	"./img/blog/12.jpg": 78593,
	"./img/blog/13.jpg": 1354,
	"./img/blog/14.jpg": 89421,
	"./img/blog/15.jpg": 1373,
	"./img/blog/How Radiologists and Fetal Medicine Experts Collaborate for Accurate Diagnosis.webp": 65813,
	"./img/blog/blog-100.png": 86202,
	"./img/blog/blog-101.png": 42142,
	"./img/blog/blog-102.png": 794,
	"./img/blog/blog-103.png": 49532,
	"./img/blog/blog-104.png": 67302,
	"./img/blog/blog-105.png": 89201,
	"./img/blog/blog-106.png": 37554,
	"./img/blog/blog-107.png": 89374,
	"./img/blog/blog-108.png": 5945,
	"./img/blog/blog-109.png": 943,
	"./img/blog/blog-110.png": 82065,
	"./img/blog/blog-111.png": 20720,
	"./img/blog/blog-112.png": 9500,
	"./img/blog/blog-113.png": 35904,
	"./img/blog/blog-114.jpg": 67098,
	"./img/blog/blog-115.jpg": 23288,
	"./img/blog/blog-116.jpg": 91610,
	"./img/blog/blog-117.jpg": 33630,
	"./img/blog/blog-118.png": 71033,
	"./img/blog/blog-119.png": 31676,
	"./img/blog/blog-120.png": 16667,
	"./img/blog/blog-121.png": 70594,
	"./img/blog/blog-122.png": 72443,
	"./img/blog/blog-123.png": 85336,
	"./img/blog/blog-124.png": 41151,
	"./img/blog/blog-125.png": 25458,
	"./img/blog/blog-126.png": 26104,
	"./img/blog/blog-127.png": 6087,
	"./img/blog/blog-128.png": 73904,
	"./img/blog/blog-129.jpeg": 77270,
	"./img/blog/blog-130.jpg": 70480,
	"./img/blog/blog-131.jpg": 14897,
	"./img/blog/blog-132.jpg": 36616,
	"./img/blog/blog-133.jpg": 9798,
	"./img/blog/blog-134.jpg": 78830,
	"./img/blog/blog-135.jpg": 87159,
	"./img/blog/blog-136.jpg": 19760,
	"./img/blog/blog-137.jpg": 6870,
	"./img/blog/blog-138.jpg": 86975,
	"./img/blog/blog-139.jpg": 63206,
	"./img/blog/blog-140.jpg": 33153,
	"./img/blog/blog-141.jpg": 75537,
	"./img/blog/blog-142.jpg": 46977,
	"./img/blog/blog-143.jpg": 58650,
	"./img/blog/blog-144.jpg": 56135,
	"./img/blog/blog-145.jpg": 24628,
	"./img/blog/blog-146.jpg": 63965,
	"./img/blog/blog-147.jpg": 52957,
	"./img/blog/blog-148.jpg": 13974,
	"./img/blog/blog-149.jpg": 43912,
	"./img/blog/blog-150.jpg": 48303,
	"./img/blog/blog-151.jpg": 28225,
	"./img/blog/blog-152.jpg": 61056,
	"./img/blog/blog-153.jpg": 42354,
	"./img/blog/blog-154.jpg": 5433,
	"./img/blog/blog-155.jpg": 73524,
	"./img/blog/blog-156.jpg": 53185,
	"./img/blog/blog-157.jpg": 50783,
	"./img/blog/blog-158.jpg": 15445,
	"./img/blog/blog-159.jpg": 64461,
	"./img/blog/blog-160.jpg": 94004,
	"./img/blog/blog-161.jpg": 18904,
	"./img/blog/blog-162.jpg": 82145,
	"./img/blog/blog-163.jpg": 22041,
	"./img/blog/blog-164.jpg": 19548,
	"./img/blog/blog-165.jpg": 26082,
	"./img/blog/blog-166.jpg": 35284,
	"./img/blog/blog-167.jpg": 33127,
	"./img/blog/blog-168.jpg": 17130,
	"./img/blog/blog-169.jpg": 4516,
	"./img/blog/blog-170.jpg": 39635,
	"./img/blog/blog-171.jpg": 65998,
	"./img/blog/blog-172.png": 76216,
	"./img/blog/blog-173.png": 77821,
	"./img/blog/blog-174.png": 74018,
	"./img/blog/blog-175.png": 37532,
	"./img/blog/blog-176.jpg": 88841,
	"./img/blog/blog-177.jpg": 53697,
	"./img/blog/blog-178.jpg": 77457,
	"./img/blog/blog-179.jpg": 61404,
	"./img/blog/blog-181.jpg": 95694,
	"./img/blog/blog-182.jpg": 3944,
	"./img/blog/blog-183.jpg": 41440,
	"./img/blog/blog-184.jpg": 59572,
	"./img/blog/blog-185.jpg": 34167,
	"./img/blog/blog-186.jpg": 63350,
	"./img/blog/blog-187.jpg": 60679,
	"./img/blog/blog-188.jpg": 32232,
	"./img/blog/blog-189.jpg": 76268,
	"./img/blog/blog-190.jpg": 8721,
	"./img/blog/blog-191.jpg": 83384,
	"./img/blog/blog-192.jpg": 69291,
	"./img/blog/blog-193.jpg": 7083,
	"./img/blog/blog-194.jpg": 65028,
	"./img/blog/blog-195.jpg": 19976,
	"./img/blog/blog-196.jpg": 87508,
	"./img/blog/blog-197.jpg": 34506,
	"./img/blog/blog-198.jpg": 92962,
	"./img/blog/blog-199.jpg": 75218,
	"./img/blog/blog-200.jpg": 3476,
	"./img/blog/blog-201.jpg": 7786,
	"./img/blog/blog-202.jpg": 74535,
	"./img/blog/blog-203.jpg": 40086,
	"./img/blog/blog-204.jpg": 71721,
	"./img/blog/blog-205.jpg": 93267,
	"./img/blog/blog-206.jpg": 1325,
	"./img/blog/blog-207.jpg": 6202,
	"./img/blog/blog-208.jpg": 89637,
	"./img/blog/blog-209.jpg": 63351,
	"./img/blog/blog-210.jpg": 81267,
	"./img/blog/blog-211.jpg": 7542,
	"./img/blog/blog-212.jpg": 98613,
	"./img/blog/blog-213.jpg": 86902,
	"./img/blog/blog-214.jpg": 63266,
	"./img/blog/blog-215.jpg": 93986,
	"./img/blog/blog-216.jpg": 70326,
	"./img/blog/blog-217.jpg": 97391,
	"./img/blog/blog-218.jpg": 34439,
	"./img/blog/blog-219.jpg": 46223,
	"./img/blog/blog-220.jpg": 74557,
	"./img/blog/blog-221.webp": 93969,
	"./img/blog/blog-222.jpg": 87294,
	"./img/blog/blog-223.webp": 42663,
	"./img/blog/blog-224.webp": 85579,
	"./img/blog/blog-225.webp": 25184,
	"./img/blog/blog-226.webp": 67985,
	"./img/blog/blog-227.webp": 98177,
	"./img/blog/blog-228.webp": 97331,
	"./img/blog/blog-229.webp": 77345,
	"./img/blog/blog-230.jpg": 87060,
	"./img/blog/blog-231.jpg": 48552,
	"./img/blog/blog-232.jpg": 9533,
	"./img/blog/blog-233-old.jpg": 38084,
	"./img/blog/blog-233.jpg": 44289,
	"./img/blog/blog-234-old.jpg": 51350,
	"./img/blog/blog-234.jpg": 42437,
	"./img/blog/blog-235.jpg": 42573,
	"./img/blog/blog-236.jpg": 14320,
	"./img/blog/blog-237.jpg": 32075,
	"./img/blog/blog-238.jpg": 50441,
	"./img/blog/blog-239.jpg": 30156,
	"./img/blog/blog-240.jpg": 30079,
	"./img/blog/blog-242.jpg": 56816,
	"./img/blog/blog-243.jpg": 82936,
	"./img/blog/blog-244.jpeg": 46576,
	"./img/blog/blog-245.jpg": 14969,
	"./img/blog/blog-246.jpg": 63600,
	"./img/blog/blog-247.jpg": 3199,
	"./img/blog/blog-248.jpg": 71717,
	"./img/blog/blog-249.jpg": 69557,
	"./img/blog/blog-250.jpg": 9167,
	"./img/blog/blog-251.jpg": 40960,
	"./img/blog/blog-252.jpg": 86389,
	"./img/blog/blog-253.jpg": 5501,
	"./img/blog/blog-254.jpg": 37260,
	"./img/blog/blog-255.jpg": 31076,
	"./img/blog/blog-28.jpg": 28206,
	"./img/blog/blog-30.jpg": 28052,
	"./img/blog/blog-31.jpg": 34054,
	"./img/blog/blog-33.jpg": 13297,
	"./img/blog/blog-34.jpg": 44532,
	"./img/blog/blog-35.jpg": 55060,
	"./img/blog/blog-36.jpg": 83779,
	"./img/blog/blog-37.jpg": 74010,
	"./img/blog/blog-38.jpg": 63438,
	"./img/blog/blog-39.jpg": 50503,
	"./img/blog/blog-40.jpg": 78643,
	"./img/blog/blog-41.jpg": 58250,
	"./img/blog/blog-42.jpg": 55237,
	"./img/blog/blog-43.jpg": 97330,
	"./img/blog/blog-44.jpg": 60944,
	"./img/blog/blog-45.jpg": 61961,
	"./img/blog/blog-46.jpg": 18698,
	"./img/blog/blog-47.jpg": 7648,
	"./img/blog/blog-48.jpg": 69648,
	"./img/blog/blog-49.jpg": 45017,
	"./img/blog/blog-50.jpeg": 99716,
	"./img/blog/blog-51.jpeg": 27766,
	"./img/blog/blog-52.jpeg": 26101,
	"./img/blog/blog-53.jpeg": 90510,
	"./img/blog/blog-54.jpg": 58453,
	"./img/blog/blog-55.jpeg": 37900,
	"./img/blog/blog-56.jpeg": 12688,
	"./img/blog/blog-57.jpeg": 63151,
	"./img/blog/blog-58.jpeg": 89126,
	"./img/blog/blog-59.jpg": 23079,
	"./img/blog/blog-60.jpg": 64532,
	"./img/blog/blog-61.jpg": 11814,
	"./img/blog/blog-62.jpeg": 43251,
	"./img/blog/blog-63.jpg": 29876,
	"./img/blog/blog-64.jpg": 43082,
	"./img/blog/blog-65.jpg": 66453,
	"./img/blog/blog-66.jpg": 51783,
	"./img/blog/blog-67.jpg": 30534,
	"./img/blog/blog-68.jpg": 37216,
	"./img/blog/blog-69.jpg": 60637,
	"./img/blog/blog-70.jpg": 18660,
	"./img/blog/blog-71.jpg": 47192,
	"./img/blog/blog-72.jpg": 58255,
	"./img/blog/blog-73.jpg": 1643,
	"./img/blog/blog-74.jpg": 65245,
	"./img/blog/blog-75.jpg": 75319,
	"./img/blog/blog-76.jpg": 8467,
	"./img/blog/blog-77.jpg": 7761,
	"./img/blog/blog-78.jpg": 3479,
	"./img/blog/blog-79.jpg": 76729,
	"./img/blog/blog-80.jpg": 85567,
	"./img/blog/blog-81.jpg": 21687,
	"./img/blog/blog-82.jpg": 80684,
	"./img/blog/blog-83.jpg": 14382,
	"./img/blog/blog-84.jpg": 30434,
	"./img/blog/blog-85.jpg": 48459,
	"./img/blog/blog-86.jpg": 81597,
	"./img/blog/blog-87.jpg": 2087,
	"./img/blog/blog-88.jpg": 58854,
	"./img/blog/blog-89.jpg": 67192,
	"./img/blog/blog-90.jpg": 26511,
	"./img/blog/blog-91.jpg": 40812,
	"./img/blog/blog-92.jpg": 33524,
	"./img/blog/blog-93.jpg": 75759,
	"./img/blog/blog-94.jpg": 28404,
	"./img/blog/blog-95.jpg": 99938,
	"./img/blog/blog-96.jpg": 12377,
	"./img/blog/blog-97.jpg": 92679,
	"./img/blog/blog-98.jpg": 6384,
	"./img/blog/blog-99.jpg": 91906,
	"./img/blog/blog-images/blog37-01.jpg": 17057,
	"./img/blog/blog-images/blog37-02.jpg": 37039,
	"./img/blog/blog-images/blog37-03.jpg": 55662,
	"./img/blog/blog1-176.jfif": 94663,
	"./img/blog/blog_12.jpg": 75180,
	"./img/blog/blog_13.jpg": 17216,
	"./img/blog/blog_14.jpg": 95033,
	"./img/blog/blog_15.jpg": 95934,
	"./img/blog/blog_16.jpg": 2448,
	"./img/blog/blog_17.jpg": 65408,
	"./img/blog/blog_18.jpg": 74099,
	"./img/blog/blog_19.jpg": 18472,
	"./img/blog/blog_20.jpg": 92637,
	"./img/blog/blog_21.jpg": 60082,
	"./img/blog/blog_22.jpg": 95121,
	"./img/blog/blog_23.jpg": 53491,
	"./img/blog/blog_24.jpg": 91124,
	"./img/blog/blog_25.jpg": 92630,
	"./img/blog/blog_26.jpg": 74277,
	"./img/blog/blog_27.jpg": 30595,
	"./img/blog/breastfeeding-women.jpg": 37172,
	"./img/blog/newborn-baby.jpg": 77092,
	"./img/blog/pneumonia-signs-treatment-prevention.jpg": 46685,
	"./img/blog/pregnancy-and-coronavirus.jpg": 3011,
	"./img/blog/soontobemom-01.jpg": 42065,
	"./img/blog1.jpg": 18974,
	"./img/blog1.webp": 91490,
	"./img/blog2.jpg": 29998,
	"./img/blog2.webp": 78654,
	"./img/blog3.jpg": 38302,
	"./img/blog3.webp": 89718,
	"./img/careers-bg-1.jpg": 16061,
	"./img/careers-bg-1.webp": 79044,
	"./img/central/arpitha-g.jpg": 52628,
	"./img/central/ashishprasad.jpg": 72455,
	"./img/central/ashoakbs.jpg": 93686,
	"./img/central/r-ramesh.png": 53953,
	"./img/central/ramesh-cfo.jpg": 8543,
	"./img/central/ramesh-cfo1.jpg": 89787,
	"./img/central/ramesh-cfo2.jpg": 78492,
	"./img/central/shekar-subbaiah-new.jpeg": 89435,
	"./img/central/shekhar-subbaiah1.jpg": 13574,
	"./img/central/shivkumar-ben.jpg": 83571,
	"./img/central/shivu1.jpg": 45277,
	"./img/dental-01.svg": 94886,
	"./img/dental-02.svg": 5229,
	"./img/desktop_1.jpg": 88987,
	"./img/desktop_2.jpg": 94585,
	"./img/desktop_3.jpg": 86307,
	"./img/desktop_4.jpg": 75337,
	"./img/diet-for-expecting-moms.jpg": 77790,
	"./img/doctor.png": 93160,
	"./img/doctors-bg.jpg": 61580,
	"./img/doctors-bg.webp": 92979,
	"./img/doctors-sec-img.jpg": 87801,
	"./img/doctors-sec-img.webp": 78958,
	"./img/doctors/AnandLingam.jpg": 30659,
	"./img/doctors/Aveen_Umashankar.jpg": 15654,
	"./img/doctors/Deepa_Bhat.jpg": 48809,
	"./img/doctors/Dr Abhilasha S.jpg.jpeg": 24060,
	"./img/doctors/Dr Mohit M.jpg.jpeg": 89545,
	"./img/doctors/Dr-rohit.jpg": 93531,
	"./img/doctors/Dr-yeshodha-s-mahesh.jpg": 17015,
	"./img/doctors/Dr.Chandan.jpg": 57667,
	"./img/doctors/Dr.Soumya.jpg": 97892,
	"./img/doctors/Dr.Srinivas_BV.jpg": 72756,
	"./img/doctors/Jyothirmayi.jpg": 78788,
	"./img/doctors/RAMESH_SINGH.jpg": 55479,
	"./img/doctors/RAVIHS.jpeg": 80525,
	"./img/doctors/SNEHA.jpeg": 5689,
	"./img/doctors/Satyanarayana.jpg": 32522,
	"./img/doctors/Suman.jpeg": 76550,
	"./img/doctors/SushmaKrishnamurthy.jpg": 57770,
	"./img/doctors/VIJAYKUMAR.jpg": 53906,
	"./img/doctors/aathira-ravindranath.png": 42234,
	"./img/doctors/aathira_ravindranath.jpg": 70775,
	"./img/doctors/abhilasha-1.jpeg": 39256,
	"./img/doctors/abhilasha-22.webp": 71096,
	"./img/doctors/abhilasha.jpg": 78397,
	"./img/doctors/ajay.jpg": 79866,
	"./img/doctors/amala-new.jpeg": 82306,
	"./img/doctors/amala.jpg": 92478,
	"./img/doctors/amritha-rao.jpg": 43788,
	"./img/doctors/amritha.jpg": 6007,
	"./img/doctors/anand-jayaram.jpg": 75043,
	"./img/doctors/anand-kumar-krishnappa.jpg": 73405,
	"./img/doctors/anand-lingan.jpg": 3392,
	"./img/doctors/anand-lingan1.jpg": 7723,
	"./img/doctors/anandLingan.jpeg": 15556,
	"./img/doctors/anil-b-jalan.png": 50666,
	"./img/doctors/anil-jalan.jpg": 17368,
	"./img/doctors/anjali-bp.jpg": 44382,
	"./img/doctors/anjana.jpg": 26839,
	"./img/doctors/anusha-new.jpg": 90192,
	"./img/doctors/aravind.jpg": 74379,
	"./img/doctors/archana-m.jpeg": 49877,
	"./img/doctors/archana.jpg": 14871,
	"./img/doctors/arif-doc-new.jpg": 91815,
	"./img/doctors/arif.jpg": 91594,
	"./img/doctors/arif_1.jpg": 61277,
	"./img/doctors/arpitha-dr-new.jpg": 99912,
	"./img/doctors/arun-raikar.jpg": 41864,
	"./img/doctors/ashika-new.JPG": 51769,
	"./img/doctors/ashika_r_prabhu.jpeg": 90866,
	"./img/doctors/ashmitha-shetty-new.png": 26372,
	"./img/doctors/ashmitha-shetty.jpg": 61557,
	"./img/doctors/ashmitha_shetty_new.png": 25662,
	"./img/doctors/ashoka-shetty-1.jpg": 6004,
	"./img/doctors/ashoka-shetty.jpg": 4981,
	"./img/doctors/ashwini-s.jpg": 74669,
	"./img/doctors/avantika.jpg": 99239,
	"./img/doctors/avinash.jpg": 94973,
	"./img/doctors/balaji-new.png": 64671,
	"./img/doctors/bharathi-k-r-doc.jpeg": 58769,
	"./img/doctors/bharathi-ramesh.jpg": 72690,
	"./img/doctors/bhavya.jpg": 64265,
	"./img/doctors/bindu-new.jpg": 55191,
	"./img/doctors/bindu.jpg": 94745,
	"./img/doctors/chaitra-rangaswamy.jpg": 72260,
	"./img/doctors/chandrika-anand.jpg": 96322,
	"./img/doctors/chaya-s-m.jpg": 11879,
	"./img/doctors/chethan.jpg": 30207,
	"./img/doctors/chethana.jpeg": 94638,
	"./img/doctors/chva_deepak_chowdari.png": 29539,
	"./img/doctors/de.nisar-ahamed.jpg": 31600,
	"./img/doctors/de.shahana.jpg": 74118,
	"./img/doctors/deepak-gowda.jpg": 29945,
	"./img/doctors/deeya.jpg": 81824,
	"./img/doctors/devaraj-m.jpg": 97058,
	"./img/doctors/dinesh.jpg": 76156,
	"./img/doctors/divyasre.jpg": 30522,
	"./img/doctors/divyasree.jpg": 91426,
	"./img/doctors/doctor_avatar_female.webp": 77244,
	"./img/doctors/dr-anjali-b-p.jpg": 64927,
	"./img/doctors/dr-anjali.jpg": 24915,
	"./img/doctors/dr-anuja.jpg": 96341,
	"./img/doctors/dr-anusha-new.JPG": 16637,
	"./img/doctors/dr-anusha.jpeg": 79809,
	"./img/doctors/dr-apoorva.png": 91833,
	"./img/doctors/dr-archana-d-v.png": 36375,
	"./img/doctors/dr-arpitha-new.JPG": 10400,
	"./img/doctors/dr-arpitha.jpg": 45151,
	"./img/doctors/dr-arvind-new.JPG": 76309,
	"./img/doctors/dr-aveen-new.JPG": 94464,
	"./img/doctors/dr-bharath-ban.jpeg": 5535,
	"./img/doctors/dr-bharath-ban1.jpeg": 55554,
	"./img/doctors/dr-bharath-ban1.jpg": 5114,
	"./img/doctors/dr-bharath.jpg": 56138,
	"./img/doctors/dr-bharathi-ramesh.png": 52590,
	"./img/doctors/dr-chandan-new.jpg": 89221,
	"./img/doctors/dr-chaya-s-m-new.png": 63500,
	"./img/doctors/dr-chethana-new.JPG": 80213,
	"./img/doctors/dr-deepak-kavandur.jpeg": 86626,
	"./img/doctors/dr-deeya-c-b.jpg": 1509,
	"./img/doctors/dr-divyashree-d-new.png": 18612,
	"./img/doctors/dr-geetha-eshwar-pillai.png": 91446,
	"./img/doctors/dr-geetha-new.png": 23134,
	"./img/doctors/dr-hema-h-r.png": 10638,
	"./img/doctors/dr-inchara-ben.jpeg": 44520,
	"./img/doctors/dr-inchara-ben1.jpg": 4611,
	"./img/doctors/dr-javgal-suraj-new.png": 53244,
	"./img/doctors/dr-jayashree-venkatesh-new.png": 21035,
	"./img/doctors/dr-kalyan-reddy.jpeg": 79935,
	"./img/doctors/dr-kalyan-reddy.jpg": 46732,
	"./img/doctors/dr-kishore-yeruru-new.png": 23540,
	"./img/doctors/dr-kshma-kamath.png": 23642,
	"./img/doctors/dr-kusuma.jpg": 36974,
	"./img/doctors/dr-leelavathi-new.JPG": 5048,
	"./img/doctors/dr-likhitha.jpg": 57439,
	"./img/doctors/dr-manjunath-mysore.jpg": 44523,
	"./img/doctors/dr-manjunatha-new.JPG": 50919,
	"./img/doctors/dr-nandini-ban.jpg": 64441,
	"./img/doctors/dr-nandini-patil.jpeg": 26623,
	"./img/doctors/dr-nanditha-nandakumar.jpg": 69572,
	"./img/doctors/dr-nanditha-new.JPG": 67006,
	"./img/doctors/dr-nanditha.jpg": 75822,
	"./img/doctors/dr-nivedita.png": 85130,
	"./img/doctors/dr-padmapriya-g-new.png": 73886,
	"./img/doctors/dr-padmapriya.jpg": 72723,
	"./img/doctors/dr-padmashree-nagraju.png": 20040,
	"./img/doctors/dr-pavitra-ramanagar.jpg": 79057,
	"./img/doctors/dr-pooja-new.JPG": 49673,
	"./img/doctors/dr-poonima-new.JPG": 39469,
	"./img/doctors/dr-prashanth-kumar.png": 94173,
	"./img/doctors/dr-prashanth-l-new.png": 27645,
	"./img/doctors/dr-praveen-new.JPG": 38219,
	"./img/doctors/dr-preethi-gowda-new.png": 55190,
	"./img/doctors/dr-preeti-allum.png": 81330,
	"./img/doctors/dr-priyanka-ravi.jpg": 19333,
	"./img/doctors/dr-priyanka-vijay-new.jpg": 11123,
	"./img/doctors/dr-punitha-new.jpg": 96453,
	"./img/doctors/dr-punnetha.jpg": 33081,
	"./img/doctors/dr-raghu-new.JPG": 44120,
	"./img/doctors/dr-ramapriya-kalkunte-new.png": 36978,
	"./img/doctors/dr-ramapriya-kalkunte-new1.jpeg": 5296,
	"./img/doctors/dr-ramya-prakash.png": 6581,
	"./img/doctors/dr-rashmi-kishor-new.JPG": 19889,
	"./img/doctors/dr-rashmi-new.JPG": 58607,
	"./img/doctors/dr-rashmi.jpg": 10502,
	"./img/doctors/dr-rasika-ravi-kumar.png": 66393,
	"./img/doctors/dr-ravi.jpg": 16250,
	"./img/doctors/dr-ravichandra-new.png": 73424,
	"./img/doctors/dr-raza-adoor.png": 39127,
	"./img/doctors/dr-sakolkar-shalmali-vilas.png": 54360,
	"./img/doctors/dr-sandhya-ban.jpeg": 95613,
	"./img/doctors/dr-sandhya-ban1.jpg": 23220,
	"./img/doctors/dr-seemasjmysore-new.png": 34512,
	"./img/doctors/dr-shahsikiran.jpg": 32092,
	"./img/doctors/dr-shalini-s-r.jpg": 22599,
	"./img/doctors/dr-shalini-s-r.png": 10738,
	"./img/doctors/dr-shashi-new.JPG": 18140,
	"./img/doctors/dr-shewtha-1.jpeg": 75212,
	"./img/doctors/dr-shewtha.jpg": 38974,
	"./img/doctors/dr-shilpa-mys.jpg": 74935,
	"./img/doctors/dr-shilpa-new.JPG": 56354,
	"./img/doctors/dr-shrithi.jpg": 59437,
	"./img/doctors/dr-shruthi-sh-new.png": 99794,
	"./img/doctors/dr-shruthi-sh.jpeg": 15621,
	"./img/doctors/dr-shubha-new.JPG": 85179,
	"./img/doctors/dr-spoorthi.jpg": 86249,
	"./img/doctors/dr-spurti-new.jpg": 36668,
	"./img/doctors/dr-srinath.png": 62941,
	"./img/doctors/dr-suman-new.png": 15053,
	"./img/doctors/dr-suman.jpg": 50817,
	"./img/doctors/dr-sunil-new.JPG": 76860,
	"./img/doctors/dr-sushma-new.JPG": 86271,
	"./img/doctors/dr-swathi-g.jpg": 16973,
	"./img/doctors/dr-tarangini.jpg": 77593,
	"./img/doctors/dr-taringini-durgappa-new.JPG": 48754,
	"./img/doctors/dr-thrupthi-new.JPG": 12963,
	"./img/doctors/dr-thrupthis.jpg": 594,
	"./img/doctors/dr-vandana.jpg": 94605,
	"./img/doctors/dr-veena-keerthi-new.jpeg": 77977,
	"./img/doctors/dr-veena-mysore.jpg": 40386,
	"./img/doctors/dr-veena-new.JPG": 75112,
	"./img/doctors/dr.madhusoodhan-new.jpeg": 92345,
	"./img/doctors/dr.priyanka.jpg": 79904,
	"./img/doctors/dr.sowmyaa.png": 22741,
	"./img/doctors/dr.sreeharsha.jpg": 2977,
	"./img/doctors/dr.suman.jpg": 48244,
	"./img/doctors/dr.varsha.jpg": 83500,
	"./img/doctors/dr.yeshoda-k-new.png": 66805,
	"./img/doctors/drSHREYASALVA.png": 42027,
	"./img/doctors/dr_aathira_ravindranath.jpg": 90626,
	"./img/doctors/drarunraykarnew.png": 29934,
	"./img/doctors/drashmitha-new.png": 71646,
	"./img/doctors/drbalaji-01.jpg": 80410,
	"./img/doctors/drbalajikc-01.jpg": 49362,
	"./img/doctors/drkavitakomandur.png": 4394,
	"./img/doctors/drmanjunath.jpg": 58414,
	"./img/doctors/drmanjunath1.jpg": 3670,
	"./img/doctors/drnarendrababunew.png": 48635,
	"./img/doctors/drnitinnayaknew.png": 53416,
	"./img/doctors/drparaasuraman.png": 79927,
	"./img/doctors/drpremalatha.jpeg": 10869,
	"./img/doctors/drramya-new.png": 1193,
	"./img/doctors/drrevati-new.png": 3034,
	"./img/doctors/drsahanan-new.png": 34896,
	"./img/doctors/drsumanthkumar.png": 31905,
	"./img/doctors/ekatha-c-n.png": 64930,
	"./img/doctors/femaledoc.png": 81764,
	"./img/doctors/gangam-new.jpg": 86922,
	"./img/doctors/gangam.jpg": 24342,
	"./img/doctors/geetha-pillai-1.jpg": 14199,
	"./img/doctors/geetha-pillai.jpg": 48848,
	"./img/doctors/harshitha-ramnagara.jpg": 63222,
	"./img/doctors/hema-h-r-new.jpg": 38594,
	"./img/doctors/hema-h-r-new1.jpeg": 63592,
	"./img/doctors/hema-h-r.jpg": 18990,
	"./img/doctors/hemalatha-ramanagar.jpg": 31902,
	"./img/doctors/indushree.jpeg": 16130,
	"./img/doctors/ishwarya.jpg": 5897,
	"./img/doctors/jacqueline-shah.jpg": 20405,
	"./img/doctors/jalajakshi.jpg": 39829,
	"./img/doctors/jamunashree.jpeg": 68190,
	"./img/doctors/javagal-s-suraj.jpg": 24076,
	"./img/doctors/jaya-kiran-new.jpg": 92271,
	"./img/doctors/jaya-kiran.png": 86317,
	"./img/doctors/jayanthi-durganna.jpg": 41998,
	"./img/doctors/jayanthi-new.png": 77246,
	"./img/doctors/jayanthi.jpg": 91782,
	"./img/doctors/jayashree.jpg": 57372,
	"./img/doctors/joewin-monteiro.jpg": 8699,
	"./img/doctors/kalyan-reddy.png": 63354,
	"./img/doctors/kav.jpg": 57624,
	"./img/doctors/kavitha-dental.jpeg": 66334,
	"./img/doctors/kavya-t.jpg": 6757,
	"./img/doctors/kavya.jpg": 82099,
	"./img/doctors/kavya_diet.jpg": 43622,
	"./img/doctors/kavyakrishnappa.jpg": 45962,
	"./img/doctors/kckavitha.jpg": 58713,
	"./img/doctors/keerthi-rajendra.jpg": 81368,
	"./img/doctors/kishore-yerur-new.jpg": 76376,
	"./img/doctors/kishore-yerur.jpg": 52589,
	"./img/doctors/kshama-kamath.jpg": 84714,
	"./img/doctors/kshma-kmth-new.png": 55516,
	"./img/doctors/lakshmi-dr.jpg": 12444,
	"./img/doctors/lakshmi-dr1.jpg": 41344,
	"./img/doctors/laxman-dr.jpg": 97421,
	"./img/doctors/leelvathi.jpg": 23857,
	"./img/doctors/leelvathi1.jpg": 60330,
	"./img/doctors/likhitha-ban.jpeg": 20642,
	"./img/doctors/likita-doc.png": 98112,
	"./img/doctors/lokeshwari-1.jpeg": 89220,
	"./img/doctors/lokeshwari-22.webp": 15719,
	"./img/doctors/lokeshwari.jpg": 80376,
	"./img/doctors/madhu-muddaiha.jpg": 4945,
	"./img/doctors/madhu-muddaihaa.jpeg": 14555,
	"./img/doctors/madhu-naidu.jpg": 21040,
	"./img/doctors/madhu-ramanagara.jpg": 44766,
	"./img/doctors/madhu.jpg": 8434,
	"./img/doctors/madhusoodan-old.jpg": 47901,
	"./img/doctors/madhusoodan.jpg": 76865,
	"./img/doctors/manasa-c.jpg": 96861,
	"./img/doctors/manjunatha.jpg": 5490,
	"./img/doctors/manjush-halbhavi.jpg": 11133,
	"./img/doctors/manjusha-nambiar.jpg": 27312,
	"./img/doctors/manjusha1.jpg": 36110,
	"./img/doctors/meena-b-m.jpg": 50101,
	"./img/doctors/meena-bm.png": 2754,
	"./img/doctors/mohit-m-1.webp": 5075,
	"./img/doctors/mohit-m.jpg": 6272,
	"./img/doctors/mr-arvind.png": 58004,
	"./img/doctors/nagarathnamma.jpg": 6955,
	"./img/doctors/nagendra-kumar-new.png": 18700,
	"./img/doctors/nagendra-kumar.jpg": 91409,
	"./img/doctors/nagendra-prasad.jpg": 67250,
	"./img/doctors/nandini-doc.png": 1028,
	"./img/doctors/nandita1.jpg": 89910,
	"./img/doctors/nanditha-m.jpg": 94654,
	"./img/doctors/narendra-babu.jpg": 39371,
	"./img/doctors/naveen-k-s.jpg": 57489,
	"./img/doctors/navneeth.jpg": 82505,
	"./img/doctors/neethu-priya-k.jpeg": 53034,
	"./img/doctors/niby-j-elackatt.jpg": 55469,
	"./img/doctors/nirmal-raj.jpg": 70430,
	"./img/doctors/nirmal1.jpg": 19477,
	"./img/doctors/nishan.jpg": 42185,
	"./img/doctors/nithin-r.jpeg": 98439,
	"./img/doctors/nitin-nayak.jpg": 44923,
	"./img/doctors/padmapriya-new.png": 53997,
	"./img/doctors/padmashree-doc-kc.jpg": 25526,
	"./img/doctors/pallavi.jpg": 62829,
	"./img/doctors/pallavi1.jpg": 27683,
	"./img/doctors/pavi.jpg": 70794,
	"./img/doctors/pooja_n_swamy.jpg": 53531,
	"./img/doctors/poornima.jpg": 87810,
	"./img/doctors/prabhakaran.jpg": 17035,
	"./img/doctors/prakash-babu.jpg": 85067,
	"./img/doctors/pramod-new.png": 77931,
	"./img/doctors/pramod.jpg": 16425,
	"./img/doctors/pramod.png": 64290,
	"./img/doctors/prashanth-inna.jpg": 93407,
	"./img/doctors/prashanth.jpg": 21301,
	"./img/doctors/praveen-n.jpeg": 69423,
	"./img/doctors/praveen.jpg": 91590,
	"./img/doctors/praveez-ahmed.jpg": 17951,
	"./img/doctors/preethi-allum.jpg": 51303,
	"./img/doctors/preethi-gowda.jpg": 3460,
	"./img/doctors/premalatha.jpeg": 16706,
	"./img/doctors/priyanka-new.jpg": 15129,
	"./img/doctors/priyanka.jpg": 9464,
	"./img/doctors/puspanjali-ramanagara.jpg": 73739,
	"./img/doctors/raghu.jpeg": 6214,
	"./img/doctors/rajeshwari-s.jpg": 65925,
	"./img/doctors/rakesh-mysore.jpeg": 60896,
	"./img/doctors/ramapriya-kalkunte.jpg": 44500,
	"./img/doctors/rame-gowda.JPG": 81357,
	"./img/doctors/rame-gowda.png": 83271,
	"./img/doctors/ramya_shankar.jpg": 92568,
	"./img/doctors/ranjitha-new.png": 864,
	"./img/doctors/rashmi-kishore.png": 8903,
	"./img/doctors/rashmi-t-s-new.jpg": 12679,
	"./img/doctors/rashmiKishore.jpeg": 13639,
	"./img/doctors/rashmiKishore.jpg": 66210,
	"./img/doctors/rashmikishore-01.jpg": 33217,
	"./img/doctors/rasika.jpeg": 1579,
	"./img/doctors/ravi-hiremagalur.png": 64668,
	"./img/doctors/ravichandra.jpg": 13046,
	"./img/doctors/revathi.png": 67356,
	"./img/doctors/roopa-pateel-dr.jpg": 59893,
	"./img/doctors/sabeena-taj.jpg": 59560,
	"./img/doctors/sachin-dharwadkar.jpg": 31817,
	"./img/doctors/sagetya.jpg": 60938,
	"./img/doctors/sahana-ramanagara.jpg": 33001,
	"./img/doctors/sahana.png": 68756,
	"./img/doctors/santhosh-ramanagara.jpg": 71898,
	"./img/doctors/santhosh_kumar.jpeg": 70232,
	"./img/doctors/santhoshkumar-1.jpeg": 92141,
	"./img/doctors/santosh-olety-sathyanarayana.jpg": 75318,
	"./img/doctors/saraswati-vishwanatha.png": 86649,
	"./img/doctors/saraswati-viswanathan.jpg": 97904,
	"./img/doctors/sathish-babu.jpg": 90310,
	"./img/doctors/satosh-babu-new.png": 6136,
	"./img/doctors/satosh-babu-new1.png": 6876,
	"./img/doctors/shalini-narayan.jpg": 65787,
	"./img/doctors/shalini-new.jpg": 63456,
	"./img/doctors/shalmali-old.jpg": 21630,
	"./img/doctors/shalmali.jpeg": 20322,
	"./img/doctors/shalmali.jpg": 52468,
	"./img/doctors/shankar-singh.jpg": 95322,
	"./img/doctors/shasthara.jpg": 69749,
	"./img/doctors/shekar-subbaiah-new.jpeg": 10993,
	"./img/doctors/shekar-subbaiah-old.jpg": 46906,
	"./img/doctors/shekar-subbaiah.jpeg": 19224,
	"./img/doctors/shekar-subbaiah.jpg": 39901,
	"./img/doctors/shilpa-nadig.jpeg": 53718,
	"./img/doctors/shilpa_n_vijay.jpg": 53594,
	"./img/doctors/shivachandra.jpg": 98336,
	"./img/doctors/shreenath-bangalore.jpg": 11142,
	"./img/doctors/shreyas.jpg": 21662,
	"./img/doctors/shristi-v.png": 44864,
	"./img/doctors/shruthi-ramanagar.jpg": 43340,
	"./img/doctors/shubha-mysore.jpg": 72824,
	"./img/doctors/shwetha-b-m.jpeg": 90804,
	"./img/doctors/siddarth_warad.jpeg": 97486,
	"./img/doctors/siri-gowri-s.jpeg": 11558,
	"./img/doctors/smita.jpg": 26084,
	"./img/doctors/smitha-shetty.jpg": 22460,
	"./img/doctors/sneha1.jpg": 84064,
	"./img/doctors/soumya-arudi-nagarajan.jpg": 83024,
	"./img/doctors/soumya-jpg.jpg": 61696,
	"./img/doctors/spurtii.jpeg": 15,
	"./img/doctors/spurtii.jpg": 88506,
	"./img/doctors/sree-harsha.png": 47509,
	"./img/doctors/srushti.jpg": 54248,
	"./img/doctors/subramya-new.jpg": 57161,
	"./img/doctors/subramya.jpg": 87410,
	"./img/doctors/suchitra-sl.jpg": 29988,
	"./img/doctors/sumalatha_k_b.jpeg": 15203,
	"./img/doctors/suman-r-k.jpg": 95140,
	"./img/doctors/sunayana-nagendra-s-1.jpg": 4924,
	"./img/doctors/sunayana-nagendra-s.jpg": 87853,
	"./img/doctors/suneel.jpg": 42865,
	"./img/doctors/suneetha.jpeg": 64241,
	"./img/doctors/sunil-mysore-new.jpg": 67937,
	"./img/doctors/supriya-bhandage.jpeg": 71360,
	"./img/doctors/sushma.jpg": 74612,
	"./img/doctors/sushmitha-r.png": 56332,
	"./img/doctors/swaroop.jpeg": 94121,
	"./img/doctors/swathi-g-new.png": 6211,
	"./img/doctors/swathi-g-old.png": 36506,
	"./img/doctors/swathi-g.png": 52323,
	"./img/doctors/swathi1.jpg": 66750,
	"./img/doctors/swatihkmysore-new.png": 21489,
	"./img/doctors/tarun-javeli.jpeg": 67940,
	"./img/doctors/testDoctor.png": 20458,
	"./img/doctors/thrupthi-new.jpg": 86199,
	"./img/doctors/tripti-mirza-new.jpg": 5663,
	"./img/doctors/trupti-1.jpg": 77643,
	"./img/doctors/varun-new.jpg": 89125,
	"./img/doctors/varun_ramnagara.jpg": 45300,
	"./img/doctors/veena.jpg": 82515,
	"./img/doctors/veerendarsingh-b.jpeg": 9733,
	"./img/doctors/vibha.jpg": 16408,
	"./img/doctors/vibha1.jpg": 3435,
	"./img/doctors/vinay-ja.jpg": 93133,
	"./img/doctors/vinay-jadh.png": 13531,
	"./img/doctors/vinay-jadhav.jpg": 14579,
	"./img/doctors/vykunta-raju-new.jpg": 87608,
	"./img/doctors/vykunta-raju.jpg": 68434,
	"./img/doctors/vyshakha-chikkanagoudar.png": 47742,
	"./img/doctors/yashaswini.jpg": 56612,
	"./img/doctors/yashaswini1.jpg": 59897,
	"./img/doctors/yashodha-k-n.jpg": 94563,
	"./img/downloads-bg.jpg": 35495,
	"./img/downloads-bg.webp": 67622,
	"./img/error.jpg": 49235,
	"./img/events-full.jpg": 72082,
	"./img/facilities-kc.jpg": 19987,
	"./img/facilities-kc.webp": 55078,
	"./img/feature/01.png": 80303,
	"./img/feature/02.png": 57591,
	"./img/feature/03.png": 97690,
	"./img/founders/dr-manjunath-new.jpg": 75723,
	"./img/founders/dr-manjunath-new2.jpg": 75129,
	"./img/founders/drmanjunath.jpg": 21666,
	"./img/founders/drmanjunath11.jpg": 26663,
	"./img/founders/drmanjunath12.jpg": 24356,
	"./img/founders/javgal-s-suraj.jpg": 84862,
	"./img/founders/praveen-k-john.jpg": 49423,
	"./img/founders/ramapriyya-kalkunte.jpg": 16312,
	"./img/founders/shekar-subbaiah-new.jpeg": 31255,
	"./img/founders/shekhar-subbaiah.jpg": 38555,
	"./img/founders/shekhar-subbaiah1.jpg": 12302,
	"./img/fw3.png": 34352,
	"./img/gallery-bg.jpg": 2836,
	"./img/gallery-bg.webp": 16464,
	"./img/gallery/breaking-down.jpg": 75023,
	"./img/gallery/child-development.jpg": 36436,
	"./img/gallery/childs-nutrition-and-digestion.jpg": 62239,
	"./img/gallery/complex-cases.jpg": 76983,
	"./img/gallery/kats-ambulance.jpg": 7487,
	"./img/gallery/mom-baby.jpg": 92483,
	"./img/gallery/pediatric-surgery.jpeg": 38032,
	"./img/gallery/pics/1.jpg": 96963,
	"./img/gallery/pics/10.jpg": 52133,
	"./img/gallery/pics/11.jpg": 85619,
	"./img/gallery/pics/12.jpg": 77553,
	"./img/gallery/pics/13.jpg": 34174,
	"./img/gallery/pics/14.jpg": 92225,
	"./img/gallery/pics/15.jpg": 55474,
	"./img/gallery/pics/16.jpg": 22831,
	"./img/gallery/pics/17.jpg": 30567,
	"./img/gallery/pics/18.jpg": 82917,
	"./img/gallery/pics/19.jpg": 92161,
	"./img/gallery/pics/1_old.jpg": 59312,
	"./img/gallery/pics/1st floor-ip-department-9.png": 14817,
	"./img/gallery/pics/2.jpg": 87607,
	"./img/gallery/pics/20.jpg": 12074,
	"./img/gallery/pics/21.jpg": 73978,
	"./img/gallery/pics/22.jpg": 13737,
	"./img/gallery/pics/23.jpg": 75380,
	"./img/gallery/pics/24.jpg": 53197,
	"./img/gallery/pics/25.jpg": 19,
	"./img/gallery/pics/26.jpg": 59471,
	"./img/gallery/pics/27.jpg": 18314,
	"./img/gallery/pics/28.jpg": 64174,
	"./img/gallery/pics/29.jpg": 20152,
	"./img/gallery/pics/2nd-floor-ip-department-10.png": 39601,
	"./img/gallery/pics/3.jpg": 28242,
	"./img/gallery/pics/30.jpg": 26689,
	"./img/gallery/pics/4.jpg": 99918,
	"./img/gallery/pics/5.jpg": 98204,
	"./img/gallery/pics/6.jpg": 15125,
	"./img/gallery/pics/7.jpg": 77495,
	"./img/gallery/pics/8.jpg": 84113,
	"./img/gallery/pics/9.jpg": 15828,
	"./img/gallery/pics/Baby Shop.jpg": 95923,
	"./img/gallery/pics/HDU.jpg": 2795,
	"./img/gallery/pics/InPatient Area.jpg": 62784,
	"./img/gallery/pics/InPatient Lobby.jpg": 64522,
	"./img/gallery/pics/LDU.jpg": 12235,
	"./img/gallery/pics/Main Lobby.jpg": 75087,
	"./img/gallery/pics/Neonatal Transport Incubator.jpg": 5210,
	"./img/gallery/pics/Operation Theatre.jpg": 31059,
	"./img/gallery/pics/Outpatient Department.jpg": 66422,
	"./img/gallery/pics/Private Room.jpg": 15154,
	"./img/gallery/pics/Radiology.jpg": 46793,
	"./img/gallery/pics/Reception.jpg": 12153,
	"./img/gallery/pics/SICU.jpg": 67368,
	"./img/gallery/pics/Semi Suit Room.jpg": 39130,
	"./img/gallery/pics/Suit Room.jpg": 17342,
	"./img/gallery/pics/baby-shop-4.png": 56190,
	"./img/gallery/pics/bangalore-old.jpg": 85635,
	"./img/gallery/pics/bangalore.jpg": 93043,
	"./img/gallery/pics/chili-pili-banner.jpg": 35173,
	"./img/gallery/pics/clinics-banner.jpg": 73475,
	"./img/gallery/pics/conference-room-bng-1.png": 73018,
	"./img/gallery/pics/dental.jpg": 99851,
	"./img/gallery/pics/dentistry-banner.webp": 78148,
	"./img/gallery/pics/diamond-12.png": 8676,
	"./img/gallery/pics/fertility-old.jpg": 2485,
	"./img/gallery/pics/fertility.jpg": 41383,
	"./img/gallery/pics/first-foot-imprint-ban.jpg": 27028,
	"./img/gallery/pics/first-foot-imprint-mys.jpg": 73800,
	"./img/gallery/pics/hospital-1.png": 47088,
	"./img/gallery/pics/hospital-bng.jpg": 9225,
	"./img/gallery/pics/kids-banner.png": 29371,
	"./img/gallery/pics/kids-web-banner.jpg": 38922,
	"./img/gallery/pics/main-lobby-2.png": 67224,
	"./img/gallery/pics/mysore-new/1st floor-OPdepartment.png": 34558,
	"./img/gallery/pics/mysore-new/Your paragraph text (13).jpg": 88257,
	"./img/gallery/pics/mysore-new/Your paragraph text (19).jpg": 96499,
	"./img/gallery/pics/mysore-new/Your paragraph text (5).jpg": 60608,
	"./img/gallery/pics/mysore-new/Your paragraph text.jpg": 64406,
	"./img/gallery/pics/mysore-new/aerobic-3391.jpg": 32887,
	"./img/gallery/pics/mysore-new/baby-shop-and-himalaya-3265.jpg": 51892,
	"./img/gallery/pics/mysore-new/cafeteria.png": 75470,
	"./img/gallery/pics/mysore-new/first-floor-ip-department-9590.jpg": 56698,
	"./img/gallery/pics/mysore-new/first-floor-op-department-3315.jpg": 80187,
	"./img/gallery/pics/mysore-new/hospital.png": 80520,
	"./img/gallery/pics/mysore-new/lab-9638.jpg": 74529,
	"./img/gallery/pics/mysore-new/library-9624.jpg": 21977,
	"./img/gallery/pics/mysore-new/main-lobby-3257.jpg": 4450,
	"./img/gallery/pics/mysore-new/nicu-in-born-3492.jpg": 81867,
	"./img/gallery/pics/mysore-new/nicu-outborn-3484.jpg": 35914,
	"./img/gallery/pics/mysore-new/obg-opd-3286.jpg": 37844,
	"./img/gallery/pics/mysore-new/obg-opd.png": 11255,
	"./img/gallery/pics/mysore-new/opd-9544.jpg": 27202,
	"./img/gallery/pics/mysore-new/pharmacy.png": 40882,
	"./img/gallery/pics/mysore-new/radiology-9559.jpg": 66258,
	"./img/gallery/pics/mysore-new/reception-3273.jpg": 59276,
	"./img/gallery/pics/mysore-new/reception.png": 53006,
	"./img/gallery/pics/mysore-new/second-floor-ip-department-9608.jpg": 43919,
	"./img/gallery/pics/mysore-new/sicu-3375.jpg": 97594,
	"./img/gallery/pics/mysore-new/triage-3414.jpg": 47395,
	"./img/gallery/pics/mysore-new/twin-sharing-3512.jpg": 53888,
	"./img/gallery/pics/mysore-new/yoga-room.png": 43358,
	"./img/gallery/pics/mysore.jpg": 93501,
	"./img/gallery/pics/nescafe.jpg": 19541,
	"./img/gallery/pics/nicu-21.png": 64717,
	"./img/gallery/pics/nicu.jpg": 92297,
	"./img/gallery/pics/obg-opd-7.png": 32566,
	"./img/gallery/pics/operation-theater-17.png": 33913,
	"./img/gallery/pics/paediatric-opd-8.png": 89402,
	"./img/gallery/pics/pharmacy-6.png": 51660,
	"./img/gallery/pics/photo-studio.jpg": 69093,
	"./img/gallery/pics/ramanagar-banner.jpg": 55916,
	"./img/gallery/pics/ramanagar-banner1.jpg": 20466,
	"./img/gallery/pics/ramanagara/inside-hospital.jpg": 76078,
	"./img/gallery/pics/ramanagara/lobby-1.jpg": 60150,
	"./img/gallery/pics/ramanagara/lobby-2.jpg": 15293,
	"./img/gallery/pics/ramanagara/main-entrance.jpg": 23188,
	"./img/gallery/pics/ramanagara/main-gate.jpg": 15115,
	"./img/gallery/pics/ramanagara/main-reception.jpg": 96979,
	"./img/gallery/pics/ramanagara/main_entrance.jpg": 76963,
	"./img/gallery/pics/ramanagara/main_gate.jpg": 6668,
	"./img/gallery/pics/ramanagara/new/IP-department.png": 20447,
	"./img/gallery/pics/ramanagara/new/NICU.png": 4107,
	"./img/gallery/pics/ramanagara/new/OBG-OPD.png": 739,
	"./img/gallery/pics/ramanagara/new/SICU-&-HDU.png": 64920,
	"./img/gallery/pics/ramanagara/new/aerobics-room.jpg": 67846,
	"./img/gallery/pics/ramanagara/new/baby-shop.jpg": 33265,
	"./img/gallery/pics/ramanagara/new/baby-shop.png": 63251,
	"./img/gallery/pics/ramanagara/new/cafeteria.jpg": 3687,
	"./img/gallery/pics/ramanagara/new/cafeteria.png": 63882,
	"./img/gallery/pics/ramanagara/new/conference-room.jpg": 46434,
	"./img/gallery/pics/ramanagara/new/doctors-lounge.jpg": 4256,
	"./img/gallery/pics/ramanagara/new/first-foot-imprint-ram.jpg": 17324,
	"./img/gallery/pics/ramanagara/new/first-imprints.jpg": 56977,
	"./img/gallery/pics/ramanagara/new/hospital.jpg": 11646,
	"./img/gallery/pics/ramanagara/new/hospital.png": 90889,
	"./img/gallery/pics/ramanagara/new/ip-biling.jpg": 62434,
	"./img/gallery/pics/ramanagara/new/laboratory.jpg": 47425,
	"./img/gallery/pics/ramanagara/new/main-lobby.jpg": 85514,
	"./img/gallery/pics/ramanagara/new/nicu.jpg": 20048,
	"./img/gallery/pics/ramanagara/new/nursing-station.jpg": 30945,
	"./img/gallery/pics/ramanagara/new/nursing-station.png": 9376,
	"./img/gallery/pics/ramanagara/new/obg-opd.jpg": 20860,
	"./img/gallery/pics/ramanagara/new/ot.jpg": 68342,
	"./img/gallery/pics/ramanagara/new/peadiatrics-opd.jpg": 61104,
	"./img/gallery/pics/ramanagara/new/pharmacy.jpg": 58642,
	"./img/gallery/pics/ramanagara/new/photo-studio-ram.jpg": 17995,
	"./img/gallery/pics/ramanagara/new/platinumroom.png": 35504,
	"./img/gallery/pics/ramanagara/new/private-room.jpg": 76093,
	"./img/gallery/pics/ramanagara/new/radiology.jpg": 30721,
	"./img/gallery/pics/ramanagara/new/radiology.png": 37169,
	"./img/gallery/pics/ramanagara/new/reception.jpg": 34350,
	"./img/gallery/pics/ramanagara/new/shared-room.jpg": 48909,
	"./img/gallery/pics/ramanagara/new/sicu.jpg": 50334,
	"./img/gallery/pics/ramanagara/new/studio.jpg": 30937,
	"./img/gallery/pics/ramanagara/new/suite-room.jpg": 88533,
	"./img/gallery/pics/ramanagara/new/triage.jpg": 45396,
	"./img/gallery/pics/ramanagara/new/triage.png": 94770,
	"./img/gallery/pics/ramanagara/our-journey.jpg": 56265,
	"./img/gallery/pics/ramanagara/reception.jpg": 33398,
	"./img/gallery/pics/ramanagara/ward-room.jpg": 81015,
	"./img/gallery/pics/ramanagara/ward.jpg": 59178,
	"./img/gallery/pics/ramnagar-1.jpg": 52318,
	"./img/gallery/pics/ramnagar-2.jpg": 42113,
	"./img/gallery/pics/ramnagar-3.jpg": 54823,
	"./img/gallery/pics/ramnagar-4.jpg": 24167,
	"./img/gallery/pics/ramnagar-5.jpg": 95094,
	"./img/gallery/pics/ramnagar-6.jpg": 44006,
	"./img/gallery/pics/ramnagar-7.jpg": 82362,
	"./img/gallery/pics/ramnagar-8.jpg": 65050,
	"./img/gallery/pics/ramnagar_banner.jpg": 40779,
	"./img/gallery/pics/reception-3.png": 47993,
	"./img/gallery/pics/triage-5.png": 64722,
	"./img/gallery/pics/tumakuru/Baby Shop.jpg": 10601,
	"./img/gallery/pics/tumakuru/Hospital.jpg": 47164,
	"./img/gallery/pics/tumakuru/Kids .jpg": 64662,
	"./img/gallery/pics/tumakuru/NICU.jpg": 90849,
	"./img/gallery/pics/tumakuru/Private.jpg": 56585,
	"./img/gallery/pics/tumakuru/Reception.jpg": 36683,
	"./img/gallery/pics/tumakuru/SICU.jpg": 8293,
	"./img/gallery/pics/tumakuru/Semi Suite.jpg": 62655,
	"./img/gallery/pics/tumakuru/Suite .jpg": 90966,
	"./img/gallery/pics/tumakuru/Tumakuru Cafeteria.jpg": 83325,
	"./img/gallery/pics/tumakuru/labour.jpg": 70241,
	"./img/gallery/pics/tumakuru/operation theater .jpg": 72904,
	"./img/gallery/pics/tumakuru/studio.JPEG": 8093,
	"./img/gallery/pics/tumakuru/twin-sharing..jpg": 85189,
	"./img/gallery/together-we-did.jpg": 3368,
	"./img/gallery/with-baby.jpg": 13998,
	"./img/gallery/wonder-baby.jpg": 60990,
	"./img/gallery/world-prematurity-day.jpg": 43021,
	"./img/heart.png": 59125,
	"./img/home-tab-01.png": 21541,
	"./img/home-tab-01.webp": 22637,
	"./img/home-tab-02.png": 56979,
	"./img/home-tab-02.webp": 60664,
	"./img/home-tab-03.png": 43193,
	"./img/home-tab-03.webp": 96769,
	"./img/home-tab-04.png": 46550,
	"./img/home-tab-04.webp": 56928,
	"./img/home-tab-05.png": 64830,
	"./img/home-tab-05.webp": 7972,
	"./img/home-tab-06.png": 4179,
	"./img/home-tab-06.webp": 7325,
	"./img/home-tab-image-01.png": 32792,
	"./img/home-tab-image-01.webp": 95386,
	"./img/home-tab-image-02.png": 13594,
	"./img/home-tab-image-02.webp": 63695,
	"./img/home-tab-image-03.jpg": 90973,
	"./img/home-tab-image-03.webp": 89976,
	"./img/home-tab-image-04.jpg": 32740,
	"./img/home-tab-image-04.webp": 97005,
	"./img/home-tab-image-05.jpg": 75291,
	"./img/home-tab-image-05.webp": 18433,
	"./img/home-tab-image-06.jpg": 15319,
	"./img/home-tab-image-06.webp": 93798,
	"./img/icons/cancel-white.png": 90659,
	"./img/icons/cancel.png": 63797,
	"./img/icons/coloredbg.png": 97202,
	"./img/icons/loader.gif": 64637,
	"./img/icons/quote.png": 80719,
	"./img/image-content-box1.png": 19141,
	"./img/image-content-box1.webp": 99036,
	"./img/image-content-box2.png": 12310,
	"./img/image-content-box2.webp": 6435,
	"./img/job-1.png": 94762,
	"./img/job-2.png": 18538,
	"./img/job1.jpg": 27609,
	"./img/job2.jpg": 91914,
	"./img/jobsection-1.jpg": 13759,
	"./img/jobsection-2.jpg": 10178,
	"./img/journey-new.jpg": 51757,
	"./img/kangaroo-care-new-logo.png": 86053,
	"./img/kats-new-1.png": 32171,
	"./img/kats-new.jpg": 43787,
	"./img/kats-round.png": 55187,
	"./img/kats-round.webp": 59871,
	"./img/kats.jpg": 56144,
	"./img/kats.webp": 92460,
	"./img/katsbannerimage.jpg": 30200,
	"./img/kc-journey-new.jpg": 65093,
	"./img/kc-logo-header.png": 89953,
	"./img/kc-logo-pink.png": 31481,
	"./img/kclogo-01-01.png": 5199,
	"./img/loadier.gif": 71341,
	"./img/loading.gif": 60265,
	"./img/logo-dark.png": 98750,
	"./img/logo.png": 15080,
	"./img/map-for--banner-for-journey.jpg": 42057,
	"./img/map-for--banner-for-journey1.jpg": 75270,
	"./img/map-for-web-new.jpg": 11813,
	"./img/map-for-web.jpg": 87727,
	"./img/media/camp/10_camp.jpg": 93983,
	"./img/media/camp/2_5_camp.jpg": 81287,
	"./img/media/camp/4_3_camp.jpg": 89939,
	"./img/media/camp/5_camp.jpg": 36611,
	"./img/media/camp/Camp.jpg": 28779,
	"./img/media/camp/camp-1.jpg": 70290,
	"./img/media/camp/camp-2.jpg": 68116,
	"./img/media/camp/camp-4.png": 25668,
	"./img/media/camp/camp-banner.jpg": 95454,
	"./img/media/camp/camp-new-1.png": 36859,
	"./img/media/camp/camp-new-2.png": 42438,
	"./img/media/camp/camp-school.jpeg": 28308,
	"./img/media/camp/camp_11.jpg": 27386,
	"./img/media/camp/camp_13.jpg": 70887,
	"./img/media/camp/camp_14.jpg": 49253,
	"./img/media/camp/camp_15.jpg": 74457,
	"./img/media/camp/camp_16.jpg": 20382,
	"./img/media/camp/camp_17.jpg": 14611,
	"./img/media/camp/camp_18.jpg": 39771,
	"./img/media/camp/camp_5.jpeg": 41425,
	"./img/media/camp/camp_5.jpg": 41172,
	"./img/media/camp/camp_6.jpg": 2593,
	"./img/media/camp/cmap_12.jpg": 39830,
	"./img/media/camp/fertility-camp.png": 32196,
	"./img/media/camp/health-check-upp.jpg": 9681,
	"./img/media/camp/health-checkup-camp-ramanagara.jpg": 40918,
	"./img/media/downloads/about-kangaroo-care.png": 15303,
	"./img/media/downloads/about-kc.jpg": 66776,
	"./img/media/downloads/child-development-clinic.png": 63155,
	"./img/media/downloads/childdevelopmetclinic.png 2.png": 48929,
	"./img/media/downloads/diet-for-expecting-moms.jpg": 48189,
	"./img/media/downloads/diet-plain.jpg": 75597,
	"./img/media/downloads/download-sec-2.jpg": 52920,
	"./img/media/downloads/download-sec-2.webp": 19062,
	"./img/media/downloads/download-sec-3.jpg": 64411,
	"./img/media/downloads/download-sec-3.webp": 54944,
	"./img/media/downloads/download-sec-4.jpg": 24334,
	"./img/media/downloads/download-sec-4.webp": 22962,
	"./img/media/downloads/download-sec-5.jpg": 62670,
	"./img/media/downloads/download-sec-5.webp": 7621,
	"./img/media/downloads/download-sec-6.jpg": 43393,
	"./img/media/downloads/download-sec-6.webp": 73073,
	"./img/media/downloads/download-sec-7.jpg": 99205,
	"./img/media/downloads/download-sec-7.webp": 20528,
	"./img/media/downloads/new-born-hearing-test.png": 37655,
	"./img/media/downloads/new-born-screening-test.png": 59917,
	"./img/media/downloads/newsletter.jpg": 61265,
	"./img/media/downloads/pain-relief.png": 19627,
	"./img/media/downloads/pain-relif-in-labour.jpg": 52856,
	"./img/media/downloads/pediatric-gastroenterology-clinic.png": 34821,
	"./img/media/downloads/pregnancy-yoga.jpg": 76560,
	"./img/media/events/08-feb-17-events.jpg": 99849,
	"./img/media/events/1.jpg": 1910,
	"./img/media/events/10.jpg": 87822,
	"./img/media/events/11.jpg": 3342,
	"./img/media/events/11_events.jpg": 86098,
	"./img/media/events/12.jpg": 34119,
	"./img/media/events/13.jpg": 34186,
	"./img/media/events/14.jpeg": 56966,
	"./img/media/events/15.jpg": 14378,
	"./img/media/events/16.jpg": 89629,
	"./img/media/events/17-dec-17-events.jpg": 62403,
	"./img/media/events/17.jpg": 37526,
	"./img/media/events/18.jpg": 5216,
	"./img/media/events/19.jpg": 91619,
	"./img/media/events/2.jpg": 91301,
	"./img/media/events/20.jpg": 72541,
	"./img/media/events/21.jpg": 80669,
	"./img/media/events/22-dec-17-events.jpg": 21557,
	"./img/media/events/22.jpg": 8459,
	"./img/media/events/23.jpg": 72957,
	"./img/media/events/24.jpg": 48634,
	"./img/media/events/25.jpg": 7878,
	"./img/media/events/26.jpg": 97560,
	"./img/media/events/29-dec-17-events.jpg": 53235,
	"./img/media/events/3.jpg": 82058,
	"./img/media/events/370_240_events.jpg": 73497,
	"./img/media/events/39.jpg": 51681,
	"./img/media/events/3_3_events.jpg": 32260,
	"./img/media/events/4.jpg": 58613,
	"./img/media/events/41.jpg": 30483,
	"./img/media/events/44.jpg": 42870,
	"./img/media/events/47.jpg": 62792,
	"./img/media/events/5.jpg": 20752,
	"./img/media/events/6.jpg": 30272,
	"./img/media/events/6_events.jpg": 4806,
	"./img/media/events/7.jpg": 45694,
	"./img/media/events/70-independence-day.jpg": 69403,
	"./img/media/events/70-independence-day1.jpg": 12010,
	"./img/media/events/7_events.jpg": 9129,
	"./img/media/events/8.jpg": 60460,
	"./img/media/events/8_events.jpg": 90771,
	"./img/media/events/9-may-17-events.jpg": 83082,
	"./img/media/events/9.jpg": 7174,
	"./img/media/events/BLS-Mock-Drill.jpg": 21245,
	"./img/media/events/Basic-life-support-training.jpg": 63356,
	"./img/media/events/Breast feeding week.jpg": 43759,
	"./img/media/events/CME-Dharawad.jpg": 26950,
	"./img/media/events/Community-Service.jpg": 59759,
	"./img/media/events/Employees-Induction-Program.jpg": 94242,
	"./img/media/events/Ganesh-Chaturthi-Celebration.jpg": 44635,
	"./img/media/events/NABH-Infection-control-training.jpg": 49914,
	"./img/media/events/NABH-training.jpg": 84633,
	"./img/media/events/Participated-in-Neonatology-and-Perinataolgy-panel-discussion.jpg": 1321,
	"./img/media/events/Planet-kids-campaign.jpg": 33925,
	"./img/media/events/VCN-doctors-meeting.jpg": 94679,
	"./img/media/events/antinatal-workshops.jpg": 89659,
	"./img/media/events/baby-94.jpeg": 14512,
	"./img/media/events/baby-shower-1.jpg": 5289,
	"./img/media/events/baby-shower-bangalore.jpg": 50985,
	"./img/media/events/baby-shower-ram-june28.jpg": 98789,
	"./img/media/events/baby-shower.jpg": 60783,
	"./img/media/events/babyshowerevent-1.jpg": 71270,
	"./img/media/events/babyshowerevent-2.jpg": 75175,
	"./img/media/events/bng.jpg": 95434,
	"./img/media/events/celebration-cd.jpg": 78051,
	"./img/media/events/celebration-cd.png": 59433,
	"./img/media/events/childvaccination-01.jpg": 58273,
	"./img/media/events/clinic-nagara-2.jpg": 80968,
	"./img/media/events/clinic-nagara-3.jpg": 28667,
	"./img/media/events/clinic-nagara-4.jpg": 68483,
	"./img/media/events/dentistry.jpg": 40723,
	"./img/media/events/doc-day.jpeg": 78015,
	"./img/media/events/doctors-july1st.jpg": 82221,
	"./img/media/events/event-1.jpg": 26588,
	"./img/media/events/event-3.jpg": 90073,
	"./img/media/events/event-A-30-1ug-2019.png": 20281,
	"./img/media/events/event-B-30-1ug-2019.png": 19749,
	"./img/media/events/event-banner.jpg": 89664,
	"./img/media/events/event-new-1.png": 83355,
	"./img/media/events/event-new-2.png": 44816,
	"./img/media/events/event-new-3.png": 41597,
	"./img/media/events/event-new-5.png": 76611,
	"./img/media/events/event-new-6.png": 86854,
	"./img/media/events/event-new-7.png": 33971,
	"./img/media/events/event-new-8.png": 7001,
	"./img/media/events/event-yoga-day.jpg": 97270,
	"./img/media/events/female-bikers-in-town.jpg": 20921,
	"./img/media/events/grand-inauguration-ceremony.jpg": 82979,
	"./img/media/events/health-checkup-ramanagara.jpg": 65145,
	"./img/media/events/kc-95.jpeg": 41976,
	"./img/media/events/mys.jpg": 73089,
	"./img/media/events/nagarabhavi-clinic.jpg": 36715,
	"./img/media/events/national-gastroneocon.jpg": 81574,
	"./img/media/events/news-letter-launch-1.png": 56626,
	"./img/media/events/news-letter-launch-2.png": 22507,
	"./img/media/events/nurse-day.jpg": 92619,
	"./img/media/events/nurses-quiz-competition.jpg": 59858,
	"./img/media/events/onam-celebration.jpg": 25421,
	"./img/media/events/oneyr-complete.jpg": 41153,
	"./img/media/events/organized-children's-day.jpg": 45107,
	"./img/media/events/orientation.png": 25505,
	"./img/media/events/prematurity-collage.jpg": 12851,
	"./img/media/events/prematurity-collage.png": 19031,
	"./img/media/events/ram.jpg": 57009,
	"./img/media/events/traning.png": 62856,
	"./img/media/events/tumakurupooja.jpg": 83511,
	"./img/media/events/women's-day-celebrationn.jpg": 18829,
	"./img/media/events/women-mysore.jpg": 76893,
	"./img/media/events/women-sday.jpg": 93689,
	"./img/media/events/womens-day-celebration-2018.jpg": 23498,
	"./img/media/events/yoga-day-june21-.jpg": 65244,
	"./img/media/newspaper-bg.jpg": 77984,
	"./img/media/newspaper-bg.webp": 62861,
	"./img/media/packageimage/child-2.jpg": 44799,
	"./img/media/packageimage/child-3.jpg": 85884,
	"./img/media/packageimage/obesity-package.jpg": 39281,
	"./img/media/packageimage/package-01.jpg": 97982,
	"./img/media/packageimage/package-02.jpg": 28824,
	"./img/media/packageimage/package-03-men-fertility-care.jpg": 28957,
	"./img/media/packageimage/package-04-women-fertility-care.jpg": 35948,
	"./img/media/packageimage/package-05.jpg": 64656,
	"./img/media/packageimage/package-10.jpg": 97458,
	"./img/media/packageimage/package-pcos.jpg": 4983,
	"./img/media/packageimage/package-women-health.jpg": 49425,
	"./img/media/packageimage/women-diabetic.jpg": 79638,
	"./img/media/packageimage/women-quickscreening.jpg": 12254,
	"./img/media/press-release-full.jpg": 78313,
	"./img/media/press-release-mob.jpg": 67921,
	"./img/media/press/asset12-50.jpg": 89885,
	"./img/media/press/asset13-50.jpg": 99105,
	"./img/media/press/asset14-50.jpg": 19131,
	"./img/media/press/asset15-50.jpg": 55062,
	"./img/media/press/asset16-50.jpg": 54407,
	"./img/media/press/asset17-50.jpg": 87119,
	"./img/media/press/asset18-50.jpg": 34823,
	"./img/media/press/pratinidhi.jpeg": 97214,
	"./img/media/press/premature-day.jpeg": 11989,
	"./img/media/press/prematuritydaymysore.jpg": 68404,
	"./img/media/press/prematuritydayramanagara.jpg": 44570,
	"./img/media/press/press-1.jpg": 88588,
	"./img/media/press/press-10.jpeg": 32165,
	"./img/media/press/press-11.jpeg": 81658,
	"./img/media/press/press-12.jpeg": 15081,
	"./img/media/press/press-2.jpg": 26901,
	"./img/media/press/press-3.jpg": 54359,
	"./img/media/press/press-4.jpg": 25457,
	"./img/media/press/press-5.jpg": 82689,
	"./img/media/press/press-6-old.jpeg": 61046,
	"./img/media/press/press-6.jpeg": 65055,
	"./img/media/press/press-7.jpeg": 70896,
	"./img/media/press/press-8.jpeg": 79338,
	"./img/media/press/press-8.png": 93851,
	"./img/media/press/press-9.jpeg": 48193,
	"./img/media/press/press-new-1.jpeg": 37767,
	"./img/media/press/press-new-2.jpeg": 83424,
	"./img/media/press/press-new-3.jpeg": 89342,
	"./img/nabh.png": 13678,
	"./img/nabh2.png": 63930,
	"./img/nabh3.png": 91522,
	"./img/nav.png": 32498,
	"./img/new-our-journey.jpeg": 74193,
	"./img/our-journey.jpg": 15826,
	"./img/our-packages/banner/Artboard 1 copy 2.jpg": 8834,
	"./img/our-packages/banner/Artboard 1 copy 3.jpg": 30814,
	"./img/our-packages/banner/Artboard 1 copy.jpg": 37208,
	"./img/our-packages/banner/Artboard 1.jpg": 91392,
	"./img/our-packages/details/luxury.jpg": 20682,
	"./img/our-packages/details/semi suite.jpg": 37802,
	"./img/our-packages/details/suite.jpg": 24541,
	"./img/our-packages/details/twin sharing.jpg": 95232,
	"./img/our-packages/icons/baby-book.png": 44659,
	"./img/our-packages/icons/baby-dress.png": 28413,
	"./img/our-packages/icons/baby-on-board.png": 12276,
	"./img/our-packages/icons/baby-photo-shoot.png": 9075,
	"./img/our-packages/icons/body-massage.png": 9386,
	"./img/our-packages/icons/candle-light-dinner.png": 19714,
	"./img/our-packages/icons/car-decoration.png": 2566,
	"./img/our-packages/icons/first-post-delivery.png": 20879,
	"./img/our-packages/icons/kangaroo-care-gift.png": 82802,
	"./img/our-packages/icons/luxury.png": 70547,
	"./img/our-packages/icons/semi-suite.png": 51208,
	"./img/our-packages/icons/twin-sharing.png": 90454,
	"./img/our-packages/icons/yoga-session.png": 97900,
	"./img/our-packages/luxury.jpg": 9924,
	"./img/our-packages/semi suite.jpg": 48915,
	"./img/our-packages/suite.jpg": 28979,
	"./img/our-packages/twin sharing.jpg": 27245,
	"./img/page-header.jpg": 31109,
	"./img/parallax-lab-image.jpg": 97289,
	"./img/parallax-lab-image.webp": 39050,
	"./img/portrait-of-mother-and-child-laughing-and-playing-PXEWE3Z.jpg": 80491,
	"./img/road-map-horizontal1.jpg": 84574,
	"./img/road-map-horizontal2.jpg": 90572,
	"./img/road-map-horizontal3.jpg": 30262,
	"./img/round.png": 70483,
	"./img/sec-2-bg-1.png": 25142,
	"./img/sec-2-bg-1.webp": 89035,
	"./img/separator1.png": 6401,
	"./img/separator10.svg": 92493,
	"./img/separator11.svg": 44493,
	"./img/separator12.svg": 84973,
	"./img/separator13.svg": 27417,
	"./img/separator14.svg": 76056,
	"./img/separator15.svg": 81725,
	"./img/separator16.svg": 66202,
	"./img/separator17.svg": 82115,
	"./img/separator18.svg": 97450,
	"./img/separator19.svg": 32164,
	"./img/separator2.png": 25146,
	"./img/separator20.svg": 34170,
	"./img/separator3.svg": 24478,
	"./img/separator4.png": 7176,
	"./img/separator4.svg": 68731,
	"./img/separator5.svg": 10509,
	"./img/separator6.svg": 1678,
	"./img/separator7.svg": 91008,
	"./img/separator8.svg": 13766,
	"./img/separator9.svg": 3722,
	"./img/service/child-care-hospital-new.png": 81001,
	"./img/service/child-development.png": 14554,
	"./img/service/child-developmental-clinc.png": 91916,
	"./img/service/childdevelopmetclinic.png": 17232,
	"./img/service/childdevelopmetclinic.png 2-webp.webp": 6051,
	"./img/service/childdevelopmetclinic.png 2.png": 50124,
	"./img/service/cosmetic gyanecology.jpg": 63260,
	"./img/service/cosmetic-gynecology.jpeg": 58026,
	"./img/service/dental.jpg": 29242,
	"./img/service/details/bangalore-fertility.jpg": 37231,
	"./img/service/details/banners/lactation-service.jpg": 99913,
	"./img/service/details/center_fertility_center.jpg": 20026,
	"./img/service/details/child-development-clinic-new1.jpg": 31790,
	"./img/service/details/child-development-new.jpg": 48297,
	"./img/service/details/childdevelopmetclinic.png": 25355,
	"./img/service/details/cosmetic-gynecology-new1.jpg": 7119,
	"./img/service/details/cosmetic-gynecology.jpg": 50147,
	"./img/service/details/dental.jpg": 17575,
	"./img/service/details/dentistry.jpg": 46247,
	"./img/service/details/dentistry1.jpg": 65010,
	"./img/service/details/fertility-center.jpg": 58335,
	"./img/service/details/fertility-new.jpeg": 20075,
	"./img/service/details/fertility-new.jpg": 90249,
	"./img/service/details/fertility-new1.jpg": 77510,
	"./img/service/details/fetal-medicine-new.jpg": 49820,
	"./img/service/details/fetal-medicine-new1.jpg": 2811,
	"./img/service/details/gynecology-1.jpg": 9667,
	"./img/service/details/gynecology-new.jpg": 66188,
	"./img/service/details/infant-care-new.jpg": 83394,
	"./img/service/details/infant-care-paediatrics-new1.jpg": 44081,
	"./img/service/details/kangaroo-care-clinics.jpg": 745,
	"./img/service/details/kangaroo-clinics.jpg": 96630,
	"./img/service/details/kangaroo-kids.jpg": 85539,
	"./img/service/details/kids-banner.png": 1407,
	"./img/service/details/lactation-preview.jpg": 86941,
	"./img/service/details/lactation-services-new1.jpg": 83638,
	"./img/service/details/lactition.jpg": 75588,
	"./img/service/details/maternity-new.jpg": 3897,
	"./img/service/details/maternity-new1.jpg": 36144,
	"./img/service/details/mysore-fetalmedicine.jpg": 73630,
	"./img/service/details/mysore-preview-fertility.jpg": 83754,
	"./img/service/details/neonatal-icu-new1.jpg": 30507,
	"./img/service/details/neonatal-new.jpg": 75967,
	"./img/service/details/new-images/CHILD-DEVELOPMENT-CLINIC.jpg": 82226,
	"./img/service/details/new-images/COSMETIC-GYNAECOLOGY.jpg": 88520,
	"./img/service/details/new-images/FERTILITY.jpg": 39474,
	"./img/service/details/new-images/GYNAECOLOGY.jpg": 51397,
	"./img/service/details/new-images/INFANT-CARE.jpg": 4732,
	"./img/service/details/new-images/LACTATION.jpg": 78885,
	"./img/service/details/new-images/LEVEL-3B-NICU.jpg": 23657,
	"./img/service/details/new-images/PAEDIATRIC-HDU.jpg": 17924,
	"./img/service/details/new-images/RADIOLOGY.jpg": 39570,
	"./img/service/details/new-images/maternity.jpg": 73081,
	"./img/service/details/paediatric-hdu1.jpg": 53296,
	"./img/service/details/paediatric-new.jpg": 60010,
	"./img/service/details/ramanagar-preview-fertility.jpg": 28179,
	"./img/service/details/ramnagar_feature.jpg": 92009,
	"./img/service/details/service-child-development-clinic.jpg": 71042,
	"./img/service/details/service-fertility.jpg": 76990,
	"./img/service/details/service-fetalmedicine.jpg": 69327,
	"./img/service/details/service-gynaecology-1.jpg": 14796,
	"./img/service/details/service-gynaecology.jpg": 25115,
	"./img/service/details/service-maternity.jpg": 36305,
	"./img/service/details/service-nicu-1.jpg": 60002,
	"./img/service/details/service-nicu.jpg": 14210,
	"./img/service/details/service-other-facilities.jpg": 88921,
	"./img/service/details/service-pediatrics-hdu.jpg": 92034,
	"./img/service/details/service-pediatrics.jpg": 85411,
	"./img/service/details/yoga-banner.jpg": 57436,
	"./img/service/details/yoga-img.jpg": 89785,
	"./img/service/fertility.jpg": 70027,
	"./img/service/fetalmedicine.jpg": 52481,
	"./img/service/gynocology-webp.webp": 35394,
	"./img/service/gynocology.png": 32413,
	"./img/service/infantandpediatriccare.jpg": 28650,
	"./img/service/kats-new.png": 31159,
	"./img/service/kats.jpg": 88870,
	"./img/service/lactation-home-services.jpg": 68013,
	"./img/service/lactationandhomeservices.jpg": 50914,
	"./img/service/maternity.jpg": 16190,
	"./img/service/maternity1.jpg": 37952,
	"./img/service/new-banner/CHILD-DEVELOPMENT-CLINIC.jpg": 66419,
	"./img/service/new-banner/COSMETIC-GYNAECOLOGY.jpg": 49391,
	"./img/service/new-banner/GYNAECOLOGY.jpg": 79303,
	"./img/service/new-banner/INFANT-CARE.jpg": 58683,
	"./img/service/new-banner/LACTATION.jpg": 65742,
	"./img/service/new-banner/LEVEL-3B-NICU.jpg": 15807,
	"./img/service/new-banner/OBSTETRICS.jpg": 72059,
	"./img/service/new-banner/PAEDIATRIC-HDU.jpg": 83412,
	"./img/service/new-banner/RADIOLOGY.jpg": 86083,
	"./img/service/new-banner/fertiloty.jpg": 8330,
	"./img/service/new-banner/yoga-banner.jpg": 88050,
	"./img/service/nicu.jpg": 6666,
	"./img/service/old/old_serv-1.jpg": 66851,
	"./img/service/old/old_serv-2.jpg": 49093,
	"./img/service/old/old_serv-3.jpg": 28579,
	"./img/service/old/old_serv-4.jpg": 86030,
	"./img/service/old/old_serv-6.jpg": 60617,
	"./img/service/old/serv-1-old.jpg": 67630,
	"./img/service/old/serv-2-old.jpg": 51137,
	"./img/service/old/serv-3-old.jpg": 22126,
	"./img/service/old/serv-4-old.jpg": 51637,
	"./img/service/old/serv-6-old.jpg": 1884,
	"./img/service/pediatrichdu.jpg": 93280,
	"./img/service/serv-1.jpg": 55439,
	"./img/service/serv-1.webp": 91451,
	"./img/service/serv-2.jpg": 49446,
	"./img/service/serv-2.webp": 89984,
	"./img/service/serv-3.jpg": 40255,
	"./img/service/serv-3.webp": 40435,
	"./img/service/serv-4.jpg": 59429,
	"./img/service/serv-4.webp": 63385,
	"./img/service/serv-5.jpg": 36826,
	"./img/service/serv-5.webp": 77884,
	"./img/service/serv-6.jpg": 5172,
	"./img/service/serv-6.webp": 47480,
	"./img/service/serv-new-1.jpg": 28562,
	"./img/service/serv-new-2.jpg": 97521,
	"./img/service/serv-new-3.jpg": 87711,
	"./img/service/serv-new-4.jpg": 43823,
	"./img/service/serv-new-5.jpg": 22636,
	"./img/service/serv-new-6.jpg": 59696,
	"./img/service/service-bg-1.jpg": 7749,
	"./img/service/service-bg-1.webp": 82014,
	"./img/service/service-icon-1.png": 1367,
	"./img/service/service-icon-2.png": 99388,
	"./img/service/service-icon-3.png": 40754,
	"./img/service/service-icon-4.png": 82921,
	"./img/service/service-icon-5.png": 85834,
	"./img/service/service-icon-6.png": 2506,
	"./img/service/yoga-banner.jpg": 29511,
	"./img/slider/2025/1_2025_banner-webp.webp": 62604,
	"./img/slider/2025/1_2025_banner.jpg": 35854,
	"./img/slider/2025/1_2025_bannerm-webp.webp": 11641,
	"./img/slider/2025/1_2025_bannerm.jpg": 19259,
	"./img/slider/2025/20000-mob.jpg": 96716,
	"./img/slider/2025/20000.jpg": 20173,
	"./img/slider/2025/2_2025_banner-webp.webp": 40807,
	"./img/slider/2025/2_2025_banner.jpg": 40744,
	"./img/slider/2025/2_2025_bannerm-webp.webp": 54945,
	"./img/slider/2025/2_2025_bannerm.jpg": 83556,
	"./img/slider/2025/3_2025_banner-webp.webp": 82144,
	"./img/slider/2025/3_2025_banner.jpg": 40484,
	"./img/slider/2025/3_2025_bannerm-webp.webp": 78329,
	"./img/slider/2025/3_2025_bannerm.jpg": 25658,
	"./img/slider/2025/4_2025_banner_new-webp.webp": 63180,
	"./img/slider/2025/4_2025_banner_new.jpg": 50299,
	"./img/slider/2025/4_2025_bannermm-webp.webp": 56262,
	"./img/slider/2025/4_2025_bannermm.jpg": 14519,
	"./img/slider/2025/5_2025_banner-webp.webp": 6490,
	"./img/slider/2025/5_2025_banner.jpg": 23285,
	"./img/slider/2025/5_2025_bannerm-webp.webp": 77728,
	"./img/slider/2025/5_2025_bannerm.jpg": 8552,
	"./img/slider/2025/6_2025_banner-webp.webp": 3117,
	"./img/slider/2025/6_2025_banner.jpg": 54735,
	"./img/slider/2025/6_2025_bannerm-webp.webp": 92476,
	"./img/slider/2025/6_2025_bannerm.jpg": 43232,
	"./img/slider/2025/7_2025_banner-webp.webp": 29528,
	"./img/slider/2025/7_2025_banner.jpg": 11327,
	"./img/slider/2025/7_2025_bannerm-webp.webp": 83982,
	"./img/slider/2025/7_2025_bannerm.jpg": 88803,
	"./img/slider/2025/8_2025_banner.jpg": 95535,
	"./img/slider/2025/8_2025_bannerm.jpg": 95344,
	"./img/slider/2025/bannar-desktop.jpg": 55930,
	"./img/slider/2025/banner-13.jpeg": 86060,
	"./img/slider/2025/banner-big.jpg": 36957,
	"./img/slider/2025/banner-mob.jpg": 58092,
	"./img/slider/2025/bannermobile-13.jpeg": 16466,
	"./img/slider/2025/coming-soon-banner-web-webp.webp": 69429,
	"./img/slider/2025/coming-soon-banner-web.jpg": 32708,
	"./img/slider/2025/coming-soon-mobi-webp.webp": 27701,
	"./img/slider/2025/coming-soon-mobi.jpg": 5294,
	"./img/slider/2025/home-banner.jpg": 27219,
	"./img/slider/2025/kat-new-banner-mob-webp.webp": 9194,
	"./img/slider/2025/kat-new-banner-mob.jpg": 59168,
	"./img/slider/2025/kat-new-banner-webp.webp": 66153,
	"./img/slider/2025/kat-new-banner.jpg": 50185,
	"./img/slider/2025/kc-banner-home-1.jpg": 52333,
	"./img/slider/2025/kc-banner-home-1mob.jpg": 36701,
	"./img/slider/2025/kc-uagthi-mobile.jpeg": 17126,
	"./img/slider/2025/kc-ugadhi.jpeg": 97454,
	"./img/slider/2025/new-banner-10-mobile.jpeg": 44680,
	"./img/slider/2025/new-banner-10.jpeg": 49638,
	"./img/slider/2025/new-banner-2026-mobile-1.jpeg": 35546,
	"./img/slider/2025/new-banner-2026-mobile.jpeg": 56493,
	"./img/slider/2025/new-banner-2026-new.jpeg": 54802,
	"./img/slider/2025/new-banner-2026.jpeg": 39741,
	"./img/slider/2025/new-banner-9-mobile.jpeg": 45952,
	"./img/slider/2025/new-banner-9.jpeg": 9688,
	"./img/slider/2025/new-banner-desktop-kats.jpg": 19694,
	"./img/slider/2025/new-banner-mobile-kats.jpg": 39618,
	"./img/slider/2025/new-banner-mobile.png": 40556,
	"./img/slider/2025/new-banner.jpg": 20373,
	"./img/slider/2025/tumkuru-desk-banner.jpeg": 962,
	"./img/slider/2025/tumkuru-mob-banner.jpg": 80201,
	"./img/slider/2025/website-banner-small.jpg": 38824,
	"./img/slider/Kids-webbanner.jpg": 53242,
	"./img/slider/banner-12.jpg": 19132,
	"./img/slider/banner-12.webp": 68377,
	"./img/slider/banner-13.jpg": 98641,
	"./img/slider/banner-13.webp": 58097,
	"./img/slider/banner1.jpg": 17018,
	"./img/slider/banner111.webp": 22913,
	"./img/slider/banner2.jpg": 55603,
	"./img/slider/banner2.webp": 23624,
	"./img/slider/bg-01.jpg": 13799,
	"./img/slider/bg-01.webp": 14068,
	"./img/slider/bg-02.jpg": 29389,
	"./img/slider/bg-02.webp": 52247,
	"./img/slider/bg-03.jpg": 32313,
	"./img/slider/bg-03.webp": 44783,
	"./img/slider/bg-04.jpg": 87545,
	"./img/slider/bg-04.webp": 85762,
	"./img/slider/bg-05.jpg": 96366,
	"./img/slider/bg-05.webp": 53890,
	"./img/slider/bg-06-old.jpg": 79775,
	"./img/slider/bg-06.jpg": 37275,
	"./img/slider/bg-06.webp": 41030,
	"./img/slider/bg-07.jpg": 22377,
	"./img/slider/bg-08c.jpg": 96889,
	"./img/slider/bg-09.jpg": 45029,
	"./img/slider/bg-09_old.jpg": 40745,
	"./img/slider/bg-10.jpeg": 47870,
	"./img/slider/bg-10.jpg": 17189,
	"./img/slider/desktop_1.jpg": 15503,
	"./img/slider/desktop_2.jpg": 11256,
	"./img/slider/desktop_3.jpg": 24482,
	"./img/slider/desktop_4.jpg": 31561,
	"./img/slider/fertility logo.png": 64972,
	"./img/slider/kids-webbanner.webp": 64971,
	"./img/slider/new_slider/14_1_desktop.jpg": 6755,
	"./img/slider/new_slider/14_1_desktop_1.jpg": 51135,
	"./img/slider/new_slider/14_1_mobile.jpg": 27737,
	"./img/slider/new_slider/14_2_desktop.jpg": 58669,
	"./img/slider/new_slider/14_2_mobile.jpg": 25882,
	"./img/slider/new_slider/14_3_desktop.jpg": 77596,
	"./img/slider/new_slider/14_3_mobile.jpg": 28912,
	"./img/slider/new_slider/14_4_desktop.jpg": 61878,
	"./img/slider/new_slider/14_4_desktop_1.jpg": 4744,
	"./img/slider/new_slider/14_4_mobile.jpg": 51185,
	"./img/slider/new_slider/14_5_desktop.jpg": 35996,
	"./img/slider/new_slider/14_5_mobile.jpg": 10818,
	"./img/slider/new_slider/14_6_desktop.jpg": 26854,
	"./img/slider/new_slider/14_6_mobile.jpg": 47460,
	"./img/slider/new_slider/14_7_desktop.jpg": 26295,
	"./img/slider/new_slider/14_7_mobile.jpg": 62387,
	"./img/slider/new_slider/14_8_desktop.jpg": 66076,
	"./img/slider/new_slider/14_8_mobile.jpg": 57615,
	"./img/slider/new_slider/3_11_2023_desktop.jpg": 97129,
	"./img/slider/new_slider/3_11_2023_desktop_clinic.jpg": 83846,
	"./img/slider/new_slider/3_11_2023_desktop_dentistry.jpg": 97120,
	"./img/slider/new_slider/3_11_2023_desktop_fertility.jpg": 35856,
	"./img/slider/new_slider/3_11_2023_desktop_kats.jpg": 16125,
	"./img/slider/new_slider/3_11_2023_desktop_nicu.jpg": 31252,
	"./img/slider/new_slider/3_11_2023_mobile.jpg": 95458,
	"./img/slider/new_slider/3_11_2023_mobile_clinic.jpg": 75993,
	"./img/slider/new_slider/3_11_2023_mobile_dentistry.jpg": 41867,
	"./img/slider/new_slider/3_11_2023_mobile_fertility.jpg": 15495,
	"./img/slider/new_slider/3_11_2023_mobile_kats.jpg": 93940,
	"./img/slider/new_slider/3_11_2023_mobile_nicu.jpg": 16582,
	"./img/slider/new_slider/banner-11.jpg": 90581,
	"./img/slider/new_slider/banner-22.jpg": 54339,
	"./img/slider/new_slider/banner-77.jpg": 99731,
	"./img/slider/new_slider/banner-80-mobile.jpg": 28030,
	"./img/slider/new_slider/banner-80.jpg": 35818,
	"./img/slider/new_slider/banner_1.jpg": 65131,
	"./img/slider/new_slider/banner_10_desktop.jpg": 50385,
	"./img/slider/new_slider/banner_10_mobile.jpg": 4244,
	"./img/slider/new_slider/banner_2.jpg": 5938,
	"./img/slider/new_slider/banner_3.jpg": 36931,
	"./img/slider/new_slider/banner_4.jpg": 85525,
	"./img/slider/new_slider/banner_9_desktop.jpg": 41838,
	"./img/slider/new_slider/banner_9_mobile.jpg": 70172,
	"./img/slider/new_slider/banner__1.jpg": 96597,
	"./img/slider/new_slider/banner__2.jpg": 85901,
	"./img/slider/new_slider/banner__3.jpg": 15041,
	"./img/slider/new_slider/banner__4.jpg": 16665,
	"./img/slider/new_slider/banner_collage.jpg": 49884,
	"./img/slider/new_slider/banner_collage_mobile.jpg": 81981,
	"./img/slider/new_slider/bengaluru-mobile.jpg": 76501,
	"./img/slider/new_slider/bengaluru.jpg": 93455,
	"./img/slider/new_slider/desk1306.jpg": 76462,
	"./img/slider/new_slider/desk13062.jpg": 82334,
	"./img/slider/new_slider/fertility-mobile.jpg": 53539,
	"./img/slider/new_slider/fertility.jpg": 5038,
	"./img/slider/new_slider/kats-1520-350.jpg": 4690,
	"./img/slider/new_slider/kats-500-500.jpg": 13420,
	"./img/slider/new_slider/kc-banner-88.jpg": 65730,
	"./img/slider/new_slider/mob1306.jpg": 52170,
	"./img/slider/new_slider/mob13062.jpg": 63025,
	"./img/slider/new_slider/mobile_1.jpg": 9009,
	"./img/slider/new_slider/mobile_2.jpg": 77282,
	"./img/slider/new_slider/mobile_3.jpg": 86850,
	"./img/slider/new_slider/mobile_4.jpg": 99870,
	"./img/slider/new_slider/mysore.jpg": 24448,
	"./img/slider/new_slider/website-banner-fertility.jpg": 78021,
	"./img/slider/new_slider/website-banner-fertility1.jpg": 87251,
	"./img/slider/new_slider/website-banner-fertility2.jpg": 12015,
	"./img/slider/new_slider/website-banner-fertilityph.jpg": 6375,
	"./img/slider/slider-10.jpg": 10549,
	"./img/slider/slider-11.jpg": 22951,
	"./img/slider/women_s_day_banner-01.jpg": 79367,
	"./img/spurtii.jpeg": 15381,
	"./img/stage1.png": 21151,
	"./img/stage1.webp": 17558,
	"./img/stage2.png": 86049,
	"./img/stage2.webp": 69338,
	"./img/stage3.png": 20272,
	"./img/stage3.webp": 19279,
	"./img/team/01.jpg": 57569,
	"./img/team/02.jpg": 84722,
	"./img/team/03.jpg": 52390,
	"./img/team/04.jpg": 31901,
	"./img/team/05.jpg": 65724,
	"./img/team/06.jpg": 59856,
	"./img/team/details/date-1.png": 54486,
	"./img/team/details/date-2.png": 68892,
	"./img/team/details/date-3.png": 99587,
	"./img/team/h-2-01.png": 83878,
	"./img/team/h-2-02.png": 92076,
	"./img/team/h-2-03.png": 87650,
	"./img/team/h-2-04.png": 14843,
	"./img/team/team-arrow.png": 68477,
	"./img/team/team-bg-2.jpg": 3119,
	"./img/team/team-bg.jpg": 73843,
	"./img/team/team-details.jpg": 79171,
	"./img/testimonial/bg-dot.png": 34299,
	"./img/testimonial/client-01.jpg": 21726,
	"./img/testimonial/client-02.jpg": 16337,
	"./img/testimonial/client-03.jpg": 70538,
	"./img/testimonial/h-2-t-01.png": 81689,
	"./img/testimonial/h-2-t-02.png": 18635,
	"./img/testimonial/h-2-t-03.png": 1751,
	"./img/title6.png": 83629,
	"./img/tumkur.jpg": 17550,
	"./img/uc.jpg": 29080,
	"./img/uc.webp": 77545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77528;